import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localeFromPathname } from '@/i18n/locales';

export function useLocaleSync(): void {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = localeFromPathname(pathname);
    if (i18n.language?.slice(0, 2) !== locale) {
      i18n.changeLanguage(locale);
    }
    document.documentElement.lang = locale;
  }, [pathname, i18n]);
}
